// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1hkrO","title":"Header_title__1Zwez","left":"Header_left__HMZ2J","clinicName":"Header_clinicName__38a8V"};